export default {"src":"/_next/static/media/disoriented.5fa01de9.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};